export const SavedFilterUrlParam = "filter_id";
